"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateApi = void 0;
const index_1 = require("./index");
const Request_1 = __importDefault(require("./Request"));
const exceptions_1 = require("./exceptions");
const HandlerAsync_1 = __importDefault(require("../exceptions/HandlerAsync"));
const auth_1 = require("../auth");
const Auth_1 = __importDefault(require("./middlewares/Auth"));
const RefreshExpiredToken_1 = __importDefault(require("./middlewares/RefreshExpiredToken"));
class PrivateApiRequest extends Request_1.default {
    constructor() {
        super('');
        this.api = index_1.Api;
    }
    async request(config) {
        return new HandlerAsync_1.default(async () => await this.api.middleware([Auth_1.default, RefreshExpiredToken_1.default], async () => await this.api.request(config)), e => {
            if (e instanceof exceptions_1.Unauthorized) {
                auth_1.Auth.signout();
            }
        });
    }
}
const PrivateApi = new PrivateApiRequest();
exports.PrivateApi = PrivateApi;
